export default __webpack_public_path__ + "media/images/logos/m_logo_dark-3f2bf247b8ed82e2ce42550a445e72d7.png";